import * as React from 'react'
import Paper from '@mui/material/Paper'
import InputBase from '@mui/material/InputBase'
//import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import SearchIcon from '@mui/icons-material/Search'
import Pagination from '../Pagination/Paginate'
import { Box, Button, Typography } from '@mui/material'
import { Section } from '../Sections'
import { getPaginate } from '../../services/utils'

export const arraySearch = (array, keyword, input) => {
    
    const searchTerm = keyword.toLowerCase()
    return array.filter(value => {
        
        return value
            [input.label]
            .toLowerCase()
            .match(new RegExp(searchTerm, 'g'))
    })

}

export default function Search({
    items, 
    input, 
    handleSelect,  
    totalByPerPage,
    children
}) {

    const [ count   , setCount        ] = React.useState(0)
    const [ page    , setPage         ] = React.useState(1)
    const [ data    , setData         ] = React.useState([])
    const [ isSearch, setIsSearch     ] = React.useState(false)
    const [ dataSearch, setDataSearch ] = React.useState([])

    const handleChange = async e => {

        const keyword = e.target.value

        const data  = await arraySearch(items, keyword, input)
        const withPaginate = getPaginate(data, totalByPerPage, page)
        setDataSearch(data)
        setIsSearch(true)
        setPage(1)

        if (keyword === '') {
            setIsSearch(false)
            setDataSearch([])
        } else {
            
            setCount(Math.ceil(data.length / totalByPerPage))
            setData(withPaginate)
        }
        
    } 

    const changePage = p => { 
        setPage(p)
        const withPaginate = getPaginate(dataSearch, totalByPerPage, p)
        setCount(Math.ceil(dataSearch.length / totalByPerPage))
        setData(withPaginate)
        
    }

    const NotFound = () => {
        if (isSearch && dataSearch.length === 0) {
            return <>
                {/* <Title hidden title={'Não encontrado'} />  */}
                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: 'column',
                    justifyContent: 'center',  
                    marginTop: '20px', 
                   
                }}>
                    
                    <Typography 
                        textAlign={'center'}
                        variant="p" 
                        component="p"
                        
                    >Ops, parece que não conseguir encontrar.</Typography>.
                    <Button size={'large'} href={'/central-agendamento'} variant={'contained'} children={'Central atendimento'} />
                </Box>
            </>
        }

        return null
    }

    return ( 
        <>
            <Paper
                component="form"
                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', boxShadow: 'none'}}
            >
                <InputBase
                    onChange={handleChange}
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Buscar..."
                    inputProps={{ 'aria-label': 'Pesquisar' }}
                    size={'large'}
                />
                <IconButton sx={{ p: '10px' }} aria-label="search">
                    <SearchIcon />
                </IconButton>
            </Paper>
            {!isSearch ? children : 
                <>  
                    <NotFound />
                    <Box sx={{
                        py: 2,
                        bgcolor: 'background.default',
                        display: 'grid',
                        gridTemplateColumns: { md: '1fr 1fr 1fr 1fr', xs: '1fr 1fr' },
                        gap: 2,
                        wrap: 'no-wrap'
                    }} >
                        
                        {data.map((item, i) => <Section 
                                label={input.label}
                                selectItem={() => handleSelect(item, input.name)} 
                                item={item} 
                                key={i} 
                            /> 
                        )}
                    </Box> 
                    <Pagination 
                        items={data} 
                        totalByPerPage={totalByPerPage} 
                        changePage={changePage}
                        count={count} 
                        page={page}
                    />
                </>}
        </> 
           
    )
}